import { render, staticRenderFns } from "./WhatbaseballPage.vue?vue&type=template&id=f2bea2f4&scoped=true"
import script from "./WhatbaseballPage.vue?vue&type=script&lang=js"
export * from "./WhatbaseballPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bea2f4",
  null
  
)

export default component.exports